import styled from 'styled-components';

export const DraggableContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 16px;
	flex-grow: 1;
	padding: 16px 0;
	flex-wrap: wrap;
	max-width: 100%;
	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		flex-direction: column;
	}
`;

export const TicketCardContainer = styled.div`
	position: relative;
	display: flex;
	background: #ffffff;
	border: 1px solid #e0e0e0;
	border-radius: 12px;
	padding: 20px;
	padding-right: 12px;
	transition: all 0.2s ease;
	max-width: 450px;
	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		max-width: 100%;
	}
`;

export const CardContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	gap: 16px;
`;

export const LeftSection = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	flex: 1;
	max-width: calc(100% - 40px);
`;

export const DragHandleContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 4px;
	cursor: grab;

	&:active {
		cursor: grabbing;
	}

	svg {
		width: 20px;
		height: 20px;
		opacity: 0.5;
	}
`;

export const StatusIndicator = styled.div`
	width: 12px;
	height: 12px;
	border-radius: 50%;
	background-color: #4caf50;
	flex-shrink: 0;
`;

export const TicketInfo = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	flex: 1;
	min-width: 0;
`;

export const TitleRow = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	min-width: 0;
	width: 100%;
`;

export const TicketName = styled.div`
	font-size: 16px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.black};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	line-height: 24px;
`;

export const InfoRow = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`;

export const InfoText = styled.div`
	font-size: 14px;
	color: ${({ theme }) => theme.colors.lightGrey10};

	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const ActionButton = styled.div`
	font-size: 32px;
	color: #999999;
	line-height: 1;
	flex-shrink: 0;

	&:hover {
		transform: scale(1.4);
	}
	cursor: pointer;
`;

export const TooltipWrapper = styled.div`
	min-width: 0;
	max-width: 100%;
	overflow: hidden;
	flex: 1;
	display: flex;
`;
